import Vue from 'vue'
import App from './App.vue'
import router from './router'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faCoffee, faSignInAlt, faSignOutAlt, faAt, faLock, faTimes, faFile,
  faMap, faUserCircle, faCaretDown, faCaretUp, faBars, faChevronDown, faMapMarker,
  faCarCrash, faCalendar, faPhone, faEnvelope, faComments, faNewspaper,
  faChevronRight, faChevronLeft, faInfo, faInfoCircle, faComment, faCopyright, 
  faChevronUp, faArrowUp, faMapMarked, faFireExtinguisher, faEnvelopeSquare, faCloud, 
  faPlayCircle, faExpandArrowsAlt, faSync, faFire, faSpinner, faQrcode, faCaretRight, 
  faSortAmountUp, faSort, faSortNumericUp, faSortAmountDown, faSortAlphaDown, 
  faSortNumericDown, faPrint, faSave, faFileAlt, faLink, faPlus, faEdit, faTrash, 
  faClock, faUser, faCog, faHeading, faTags, faFileUpload, faImage, faImages, 
  faFilePdf, faPlusCircle, faExpand, faArrowRight, faArrowLeft, faMapPin, faCircle, 
  faMinus, faArrowDown, faSearch, faDotCircle, faGlobe } from '@fortawesome/free-solid-svg-icons'

import { FontAwesomeIcon, FontAwesomeLayers } from '@fortawesome/vue-fontawesome'
import VModal from 'vue-js-modal'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueSession from 'vue-session'
import wysiwyg from "vue-wysiwyg"
import infiniteScroll from 'vue-infinite-scroll'
import VueLazyLoad from 'vue-lazyload'
import vuescroll from 'vue-scroll'
import vueScrollto from 'vue-scrollto'
import es6Promise from 'es6-promise' 
import vueAnalytics from 'vue-analytics'
import VTooltip from 'v-tooltip'

import vueHeadful from 'vue-headful';

import VueSocialSharing from 'vue-social-sharing'


es6Promise.polyfill()

import L from 'leaflet';
delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png')
});

library.add(faCoffee, faSignInAlt, faSignOutAlt, faAt, faLock,
  faPlus, faEdit, faTrash, faUser, faClock, faCog, faFileUpload, 
  faImage, faTimes, faImages, faFilePdf, faFile, faHeading, faTags, 
  faExpand, faPlusCircle, faArrowRight, faArrowLeft, faMapPin, faMap,
  faCircle, faUserCircle, faCaretDown, faCaretUp, faBars, faChevronDown,
  faMapMarker, faCarCrash, faCalendar, faPhone, faEnvelope, faComments,
  faNewspaper, faChevronRight, faChevronLeft, faInfo, faInfoCircle, faComment,
  faCopyright, faChevronUp, faArrowUp, faMapMarked, faFireExtinguisher,
  faEnvelopeSquare, faMinus, faCloud, faArrowDown, faPlayCircle, faSearch, faExpandArrowsAlt, 
  faSync, faDotCircle, faFire, faSpinner, faQrcode, faCaretRight, faSortAmountUp, faSort,
  faSortNumericUp, faSortAmountDown, faSortAlphaDown, faSortNumericDown, faPrint, faSave,
  faFileAlt, faLink, faGlobe)
  
Vue.use(VueLazyLoad)
Vue.use(VueAxios, axios)
Vue.use(VModal)
Vue.use(VueSession, {persist: true})
Vue.use(infiniteScroll)
Vue.use(vuescroll)
Vue.use(vueScrollto)
Vue.use(wysiwyg, {
  hideModules: { 
    "code": true,
    "image": true,
    "removeFormat": true
  },
  maxHeight: "20px"
})

Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('font-awesome-layers', FontAwesomeLayers)
Vue.component('vue-headful', vueHeadful);
Vue.use(VTooltip)

Vue.use(vueAnalytics, {
  id: 'UA-182947920-1',
  router
})


Vue.use(VueSocialSharing);

Vue.config.productionTip = false
axios.defaults.headers.common['X-CSRFToken'] = "BlriWUa7rS8YmZc1qawdxzM2wChtr4crGaXR6ttlmzRePG7zChWVjSqWwaa0ExEy"

require('vue-image-lightbox/dist/vue-image-lightbox.min.css')
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
